import styled, { css } from "styled-components";

export const LanguageSwitch = styled.div`
  width: ${({ theme }) => theme.rem(80)};
  position: relative;
  z-index: 100;
  
  * {
    cursor: pointer;
  }

  [class*="-indicatorContainer"] {
    padding: 0!important;
  }

  [class*="-control"] {
    > {
      div {
        padding: 0; 
      }
    }
  }
`

export const LanguageOption = styled.div`
  display: flex;

  i {
    font-size: ${({ theme }) => theme.rem(20)};
    margin-right: ${({ theme }) => theme.rem(4)};
  }
`